import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { FailedAttempts } from './components/FailedAttempts';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { HowItWorks } from './components/HowItWorks';
import { SocialProof } from './components/SocialProof';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-teal selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <Problem data-id="element-3" />
      <FailedAttempts data-id="element-4" />
      <UniqueMechanism data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <WhoIsThisFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <SocialProof data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}